import { TTableColumn } from '@treezor/design-system';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { isCardSortKeyAvailable } from '@/features/cards/store/models/card.model';
import { TAllCardsRowType } from '@/features/cards/store/models/allcards.model';

export function AllCardsHeaders({ headersList }: { headersList: (keyof TAllCardsRowType)[] }) {
  const { t } = useTranslation();

  const getHeaderLabel = useCallback(
    (label: keyof TAllCardsRowType): string => {
      switch (label) {
        case 'publicToken':
          return `${t('pages.currentProfiles.cards.card.publicToken')} & ID`;
        case 'walletId':
          return t('pages.currentProfiles.cards.card.wallet');
        case 'virtualConverted':
          return t('pages.currentProfiles.cards.card.cardType');
        case 'actions':
          return '';
        default:
          return t(`pages.currentProfiles.cards.card.${label.toString()}`);
      }
    },
    [t],
  );

  return headersList.map(
    (field: keyof TAllCardsRowType): TTableColumn<TAllCardsRowType> => ({
      name: field,
      isSortable: isCardSortKeyAvailable(field) || undefined,
      field,
      cellProps: field === 'actions' ? { className: 'w-0 p-0' } : {},
      label: (
        <div className={`w-full ${['statusCode'].includes(field.toString()) ? 'text-center' : ''}`}>
          {getHeaderLabel(field)}
        </div>
      ),
    }),
  );
}
